/** Every one-shot sound the client can play. Tuned in `SOUND_CUES`. */
export enum SoundCue {
  // UI
  UI_CLICK = 'UI_CLICK',
  UI_READY = 'UI_READY',
  UI_UNREADY = 'UI_UNREADY',
  PLAYER_JOIN = 'PLAYER_JOIN',
  PLAYER_LEAVE = 'PLAYER_LEAVE',
  UI_ERROR = 'UI_ERROR',
  // Match flow
  COUNTDOWN_TICK = 'COUNTDOWN_TICK',
  COUNTDOWN_GO = 'COUNTDOWN_GO',
  LOW_TIME_TICK = 'LOW_TIME_TICK',
  SUDDEN_DEATH_ALARM = 'SUDDEN_DEATH_ALARM',
  VICTORY = 'VICTORY',
  DEFEAT = 'DEFEAT',
  // Food
  FOOD_EAT = 'FOOD_EAT',
  RACING_SPAWN = 'RACING_SPAWN',
  RACING_WIN = 'RACING_WIN',
  RACING_LOST = 'RACING_LOST',
  RACING_EXPIRE = 'RACING_EXPIRE',
  // Life
  DEATH = 'DEATH',
  RESPAWN = 'RESPAWN',
  ELIMINATED = 'ELIMINATED',
  // Blocks
  OBSTACLE_HIT = 'OBSTACLE_HIT',
  BULLDOZER_SMASH = 'BULLDOZER_SMASH',
  CONSTRICT = 'CONSTRICT',
  BLOCK_CHARGED = 'BLOCK_CHARGED',
  ATTACK_SEND = 'ATTACK_SEND',
  ATTACK_INCOMING = 'ATTACK_INCOMING',
  BLOCK_SLAM = 'BLOCK_SLAM',
  BLOCK_DENIED = 'BLOCK_DENIED',
  // Pickups
  PICKUP_COLLECT = 'PICKUP_COLLECT',
  PICKUP_LOST = 'PICKUP_LOST',
  POWERUP_ACTIVATE = 'POWERUP_ACTIVATE',
  // Score
  TITLE_GAINED = 'TITLE_GAINED',
  TITLE_LOST = 'TITLE_LOST',
  PEAK_BONUS = 'PEAK_BONUS',
}

/** Looping background tracks. Tuned in `MUSIC_TRACKS`. */
export enum MusicTrack {
  LOBBY = 'LOBBY',
  MATCH = 'MATCH',
  SUDDEN_DEATH = 'SUDDEN_DEATH',
}
